import React from "react";
import ChatBot from "react-simple-chatbot";
import { ThemeProvider } from "styled-components";
function CustomChatbot(props) {
  const config = {
    floating: true,
    headerTitle: "Vikalp's Bot",
    hideBotAvatar: true,
    hideUserAvatar: true,
    width: "480px",
    height: "700px",
    floatingStyle: {
      width: "60px",
      height: "60px",
      bottom: "10px",
      right: "10px",
      borderStyle: "solid",
      borderWidth: "3px",
      borderColor: "hsla(0,0%,100%,.8)",
      boxShadow: "0 0 0 0.5px #4f59ff, 0 10px 14px 0 rgba(91,99,233,.3)",
    },
    "@media screen and (max-width: 800px)":{
      floatingStyle:{
          width: "50px",
          height: "50px",
          bottom: "10px",
          right: "10px"
      }
    },
    bubbleStyle: {
      fontSize: "16px",
      fontFamily: "Lato",
      padding: "15px 15px",
      margin: "5px 0",
    },
    bubbleOptionStyle: {
      fontSize: "16px",
      fontFamily: "Lato",
      padding: "10px 10px",
      margin: "5px 0",
      display: "block",
      backgroundColor: "#5d5aff1a",
      color: "#061636",
      border: "1px solid #5d5aff",
      boxShadow: "none",
      cursor: "pointer",
      opacity: "1"
    },
    footerStyle: {
      color: "#000000"
    },

    // speechSynthesis: {
    //   enable: true, 
    //   lang: 'en'
    // }
  };
  const steps = [
     {
      id: "1",
      message: "Hi! I’m Vikalp's Bot 🤖",
      trigger: "2"
     },
     {
      id: "2",
      message: "I’m just like Vikalp, but a far better conversationalist 😉",
      trigger: "3"
     },
     {
      id: "3",
      message: "How can I help you today?",
      trigger: "4"
     },
     {
      id: "4",
      options: [
        {
          value: "greet",
          label: "👋 I just wanted to say Hello!",
          trigger: "5"
        },
        {
          value: "blog",
          label: "📝 Where I can find your latest blogs.",
          trigger: "11"
        },
        {
          value: "connect",
          label: "🌐 How I can stay connected with you?.",
          trigger: "15"
        },
        { 
          value: "contact",
          label: " ☎️ How I can contact you?",
          trigger: "19"
        } 
      ],
     },
     {
      id: "5",
      message: "What is your Name?",
      trigger: "6"
     },
     {
      id: "6",
      user: true,
      trigger: "7"
     },
     {
      id: "7",
      message: "Well, hello {previousValue} !!",
      trigger: "8"
     },
     {
      id: "8",
      message: "Thanks for saying hi 😄",
      trigger: "9"
     },
     {
      id: "9",
      message: "I hope you've enjoyed browsing my work.",
      trigger: "10"
     },
     {
      id: "10",
      message: "Can I help you with anything else?",
      trigger: "4"
     },
     {
      id: "11",
      message: "You can follow me on Medium for my all latest blogs.",
      trigger: "12"
     },
     {
      id: "12",
      message: "I love to write. ✍🏻",
      trigger: "13"
     },
     {
      id: "13",
      message: "And also I explain my projects.",
      trigger: "14"
     },
     {
      id: "14",
      message: "My username of medium is @vikalpkaushik99",
      trigger: "4"
     },
     {
      id: "15",
      message: "You can follow me on Social handles",
      trigger: "16"
     },
     {
      id: "16",
      message: `Get all the links from footer of this website`,
      trigger: "17"
     },
     {
      id: "17",
      message: `You can follow me for new products.`,
      trigger: "18"
     },
     {
      id: "18",
      message: `Just by enter the email in footer`,
      trigger: "4"
     },
     {
      id: "19",
      message: "Mail me directly 📬",
      trigger: "20"
     },
     {
      id: "20",
      message: `at gmail`,
      trigger: "21"
     },
     {
      id: "21",
      message: `vikalpkaushik99`,
      trigger: "4"
     },
   ];

  const theme = {
    background: "#f5f8fb",
    fontFamily: "Lato",
    headerBgColor: "#061636",
    headerFontColor: "#fff",
    headerFontSize: "25px",
    botBubbleColor: "#fff",
    botFontColor: "#000",
    userBubbleColor: "#061636",
    userFontColor: "#fff",
  };

return (
  <ThemeProvider theme={theme}>
      <ChatBot steps={steps} {...config} />
  </ThemeProvider>
);
}

export default CustomChatbot;